enum HEADERS {
    ACCESS_TOKEN = `x-access-token`,
    ID_TOKEN = `x-id-token`,
    REFRESH_TOKEN = `x-refresh-token`,
}

export default HEADERS
